import { useState } from 'react';
import { FormField, FormInput, FormSectionTitle, FormActions, BaseModal, useToast } from '@practium/ui';
import { useCreateCulture } from '@practium/features/api';
import styles from '../../ProductFormCard/ProductFormCard.module.css';

interface AddCultureModalProps {
	isOpen: boolean;
	onClose: () => void;
	onCreated: (name: string) => void;
}

export const AddCultureModal = ({ isOpen, onClose, onCreated }: AddCultureModalProps) => {
	const toast = useToast();
	const [name, setName] = useState('');
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const { mutateAsync: createCulture } = useCreateCulture();

	const handleSubmit = async () => {
		const trimmed = name.trim();
		if (!trimmed) {
			setError('Nome é obrigatório');
			return;
		}
		setError('');
		setIsLoading(true);
		try {
			const culture = await createCulture({ name: trimmed });
			toast.success('Cultura criada com sucesso!');
			onCreated(culture.name);
			onClose();
		} catch (err) {
			toast.error(err instanceof Error ? err.message : 'Erro ao criar cultura');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title="Nova Cultura"
			isLoading={isLoading}
			actions={
				<FormActions
					onCancel={onClose}
					onSave={handleSubmit}
					isLoading={isLoading}
				/>
			}
		>
			<div className={styles.form}>
				<div className={styles.section}>
					<FormSectionTitle>Informações Gerais</FormSectionTitle>
					<div className={styles.sectionFields}>
						<FormField label="Nome" required error={error}>
							<FormInput
								placeholder="Ex.: Café"
								value={name}
								onChange={(e) => setName(e.target.value)}
								hasError={!!error}
							/>
						</FormField>
					</div>
				</div>
			</div>
		</BaseModal>
	);
};
